var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.2441C14.5376 12.2441 17 9.78171 17 6.74414C17 3.70657 14.5376 1.24414 11.5 1.24414C8.46243 1.24414 6 3.70657 6 6.74414C6 9.78171 8.46243 12.2441 11.5 12.2441Z",
    fill: "#CAC4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1521 13.7881L13.7881 20.1521C13.4951 20.4441 13.4951 20.9201 13.7881 21.2121C14.0801 21.5051 14.5561 21.5051 14.8481 21.2121L21.2121 14.8481C21.5051 14.5561 21.5051 14.0801 21.2121 13.7881C20.9201 13.4951 20.4441 13.4951 20.1521 13.7881Z",
    fill: "#CAC4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12.25C14.602 12.25 12.25 14.602 12.25 17.5C12.25 20.398 14.602 22.75 17.5 22.75C20.398 22.75 22.75 20.398 22.75 17.5C22.75 14.602 20.398 12.25 17.5 12.25ZM17.5 13.75C19.57 13.75 21.25 15.43 21.25 17.5C21.25 19.57 19.57 21.25 17.5 21.25C15.43 21.25 13.75 19.57 13.75 17.5C13.75 15.43 15.43 13.75 17.5 13.75Z",
    fill: "#CAC4D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.925 21.7564C11.886 20.6404 11.25 19.1444 11.25 17.5004C11.25 15.8174 11.917 14.2884 13.001 13.1644C12.511 13.1264 12.01 13.1064 11.5 13.1064C8.178 13.1064 5.237 13.9374 3.411 15.1824C2.018 16.1324 1.25 17.3394 1.25 18.6064V20.0564C1.25 20.5074 1.429 20.9404 1.748 21.2584C2.067 21.5774 2.499 21.7564 2.95 21.7564H12.925Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireUser);
export default __webpack_public_path__ + "static/media/fire-user.495db002.svg";
export { ForwardRef as ReactComponent };